import React, { PureComponent } from 'react';

import {
  ScatterChart,
  Tooltip,
  CartesianGrid,
  XAxis,
  YAxis,
  ZAxis,
  Scatter,
  Dot,
  ResponsiveContainer
} from "recharts";

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  ContentTitle,
  ChartAxisLabel
} from '../../../components/ui';

import { getRequest } from '../../../../../../api/ApiService';

const RenderDot = ({ cx, cy }) => {
  return (
    <Dot cx={cx} cy={cy} fill="#1F77B4" r={2.8} />
  )
}

const yAxisLabels = {
  '16.666666': 'Not Well',
  '49.999999': 'Somewhat Well',
  '83.333332': 'Very Well',
}

const xAxisLabels = {
  '12.5': 'Very Low',
  '37.5': 'Low',
  '62.5': 'High',
  '87.5': 'Very High',
}

class TeamDynamicsPerformance extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      chartData: []
    };
  }

  componentDidMount() {
    const { roundId, teams, surveysStatsByTeam } = this.props;
    getRequest(
      `${process.env.REACT_APP_API_URL}v2/games/teamgradings/?round=${roundId}`,
    )
      .then(res => {
        const teamGradings = res.body.results;

        const chartData = surveysStatsByTeam.map(surveyStatsByTeam => {
          const neededTeamGrading = teamGradings.find(teamGrading => teamGrading.team === surveyStatsByTeam.team_id);
          console.log('neededTeamGrading', neededTeamGrading);
          const neededTeamGradingWeightedValue = neededTeamGrading ? neededTeamGrading.weighted_value : 0;
          return (
            {
              x: Number(neededTeamGradingWeightedValue).toFixed(2) * 100,
              y: surveyStatsByTeam.team_work_again_percentage,
              name: teams.find(team => team.id === surveyStatsByTeam.team_id).name
            }
          )
        });
        console.log('chartData', chartData);

        const defaultChartData = chartData;

        this.setState({
          chartData: defaultChartData
        });
      })
      .catch(err => { });
  }

  customAxisTick = ({ x, y, textAnchor, payload }) => {
    const regex = /(?![^\n]{1,8}$)([^\n]{1,8})\s/g;
    const labelRows = yAxisLabels[payload.value].split(regex).filter(i => i !== '');

    const labelRowHeight = 28;
    const labelsToDisplay = labelRows.map((str, index) => {
      const newRowShift = index * labelRowHeight;
      return <tspan key={index} y={y + newRowShift} x={x}>{str}</tspan>;
    })
    return (
      <g className="recharts-layer recharts-cartesian-axis-tick">
        <text
          x={x}
          y={y}
          textAnchor={textAnchor}
          style={{
            fontSize: '16px',
            fontFamily: 'Mukta Vaani',
            fontWeight: '700',
            lineHeight: '28px',
            fill: 'rgba(0, 27, 59, 0.94)'
          }}
        >
          {labelsToDisplay}
        </text>
      </g>
    );
  }

  render() {
    const {
      chartData
    } = this.state;

    return (
      <Wrapper>
        <PreTitle>Team</PreTitle>
        <Title>Relationship | Team Dynamics & Performance</Title>
        <Text>
          <p>Now let’s look at how team cohesion might be having an impact on performance.  You would expect teams that work very well together perform better than teams that do not. However it’s not always the case.</p>
        </Text>
        <ContentContainer>
          <ContentTitle big={true}>Relationship | Collaboration to Team Performance</ContentTitle>
          <ChartAxisLabel rotated={true}>Collaboration</ChartAxisLabel>
          <ResponsiveContainer height={400} width="100%" className="scatter-chart-container">
            <ScatterChart
              margin={{
                top: 28,
                right: 40,
                bottom: 8,
                left: 70,
              }}
            >
              <CartesianGrid stroke="rgba(0, 0, 0, 0.1)" />
              <XAxis
                orientation="bottom"
                xAxisId="first"
                dataKey="x"
                type="number"
                name="Performance value"
                tickLine={false}
                tickCount={5}
                domain={[0, 100]}
                axisLine={false}
                hide={true}
              />
              <XAxis
                orientation="bottom"
                xAxisId="second"
                dataKey="x"
                type="number"
                tickLine={false}
                ticks={[12.5, 37.5, 62.5, 87.5]}
                axisLine={false}
                tickFormatter={(value) => xAxisLabels[value]}
                style={{
                  fontSize: '16px',
                  fontFamily: 'Mukta Vaani',
                  fontWeight: '700',
                  lineHeight: '28px',
                  fill: 'rgba(0, 27, 59, 0.94)'
                }}
              />
              <YAxis
                orientation="left"
                yAxisId="first"
                dataKey="y"
                type="number"
                name="Collaboration value"
                tickLine={false}
                ticks={[0, 33.333333, 66.666666, 100]}
                domain={[0, 100]}
                axisLine={false}
                hide={true}
              />
              <YAxis
                orientation="left"
                yAxisId="second"
                tickLine={false}
                axisLine={false}
                ticks={[16.666666, 49.999999, 83.333332]}
                tick={this.customAxisTick}
              />
              <ZAxis dataKey="name" name="Team name" />
              <Tooltip
                cursor={false}
                itemSorter={(item) => {
                  switch (item.dataKey) {
                    case "name":
                      return 0;
                    case "y":
                      return 1;
                    case "x":
                      return 2;
                    default:
                      return 3;
                  }
                }}
                formatter={(value, name) => name !== 'Team name' ? value + '%' : value}
              />
              <Scatter
                data={chartData}
                shape={<RenderDot />}
                xAxisId="first"
                yAxisId="first"
              />
            </ScatterChart>
          </ResponsiveContainer>
          <ChartAxisLabel>Performance</ChartAxisLabel>
        </ContentContainer>
      </Wrapper>
    );
  }

}

export default TeamDynamicsPerformance;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/pages/dynamics/team/team-dynamics-performance.js